import React, { Component } from "react"

class BookingTableHeader extends Component {
  render() {
    return (
      <div className={`stylish-table__row stylish-table__row--head  ${this.props.hideHeader ? "no-header" : ""}`}>
        <div className="stylish-table__cell v--desktop-only">
          <div>
            <span>{this.props.bookingStatus || "Status"}</span>
          </div>
        </div>
        <div className="stylish-table__cell v--desktop-only">
          <div>
            <span>{this.props.bookingDate || "Bookingdato"}</span>
          </div>
        </div>
        <div className="stylish-table__cell">
          <div>
            <span>{this.props.bookingReservationNumber || "Reservationsnr"}</span>
          </div>
        </div>
        <div className="stylish-table__cell">
          <div>
            <span>{this.props.bookingArrivalDate || "Indkørsel"}</span>
          </div>
        </div>
        <div className="stylish-table__cell">
          <div>
            <span>{this.props.bookingDepartureDate || "Udkørsel"}</span>
          </div>
        </div>
        <div className="stylish-table__cell v--desktop-only">
          <div>
            <span>{this.props.bookingCarpark || "P-anlæg"}</span>
          </div>
        </div>
        <div className="stylish-table__cell v--desktop-only">
          <div>
            <span>{this.props.bookingPrice || "Pris (DKK)"}</span>
          </div>
        </div>
        <div className="stylish-table__cell v--desktop-only">
          <div>
            <span>{this.props.bookingLicenceplate || "Nummerplade"}</span>
          </div>
        </div>
        <div className="stylish-table__cell">
          <div></div>
        </div>
      </div>
    )
  }
}

export default BookingTableHeader
